import React, { Component } from 'react';
import Home from '../pages/home';
import Privacy from '../pages/privacy';
import Tos from '../pages/tos';
import Sources from '../pages/sources';
import Stats from '../pages/stats';
import { Route } from 'react-router-dom'

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {

    return (
      <div>
        <Route exact path="/" component={Home}/>
        <Route exact path="/privacy" component={Privacy}/>
        <Route exact path="/tos" component={Tos}/>
        <Route exact path="/sources" component={Sources}/>
        <Route path="/stats/:lat/:long/:type" component={Stats}/>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/index.js